import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    const { t } = useTranslation();
    
    if (!isOpen) return null;
    
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 top-[-30px]">
            <div className="bg-white rounded-lg p-6 max-w-xl w-full mx-4">
                <h2 className="text-xl font-bold mb-4">{title}</h2>
                <p className="text-gray-600 mb-6">{message}</p>
                <div className="flex justify-end gap-4">
                    <button
                        onClick={onConfirm}
                        className="bg-red-700 text-white px-4 py-2 rounded hover:bg-red-800 w-40"
                    >
                        {t('common.yes')}
                    </button>
                    <button
                        onClick={onClose}
                        className="bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300 w-40"
                    >
                        {t('common.no')}
                    </button>
                </div>
            </div>
        </div>
    );
};
 
ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string
};

export default ConfirmationModal;